import { useRef } from 'react';

import { GridApiPro } from '@mui/x-data-grid-pro';

import { PanelGrid } from 'components/grid';
import { Block } from 'components/page';
import { useQueryDreList, useDreGridColumns, useDreGridRows } from 'pages/financeiro/dre/hooks';

export function DreGrid() {
    const grid = useRef<GridApiPro>(null);
    const { data, refetch, isFetching } = useQueryDreList({ grid });
    const columns = useDreGridColumns({ data, refetch });
    const rows = useDreGridRows({ data });

    return (
        <Block>
            <PanelGrid
                ref={grid}
                rows={rows}
                rowsCount={rows.length}
                visibleRows="all"
                reload={refetch}
                columns={columns}
                loading={isFetching}
                remote={false}
            />
        </Block>
    );
}
